module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Glasgow-4624391e22bcd4853a156138b49e9c24.svg";